export const categories = [
  { value: "animals", label: "Animaux" },
  { value: "education", label: "Éducation" },
  { value: "environment", label: "Environnement" },
  { value: "event", label: "Événements" },
  { value: "family", label: "Famille" },
  { value: "funerals", label: "Funérailles" },
  { value: "religion", label: "Religion" },
  { value: "health", label: "Santé" },
  { value: "sports", label: "Sports" },
  { value: "emergencies", label: "Urgences" },
  { value: "other", label: "Autre" },
];
